import { leadsConstants, authConstants } from '../constants';
import { LeadsApi } from '../services';

export class LeadsActions {
    static getAllLeads() {
        return (dispatch) => {
            dispatch({type: leadsConstants.GET_ALL_LEADS_REQUEST});

            LeadsApi.getAllLeads()
                .then((res) => {

                    // if user not logged in
                    if(res.status === 403) {
                        dispatch({type: authConstants.USER_LOGGED_OUT});
                    }

                    return res.json();
                })
                .then((res) => {
                    // success
                    if(res.meta.success === true) {
                        dispatch({type: leadsConstants.GET_ALL_LEADS_SUCCESS, payload: res.data});
                        return;
                    }

                    return dispatch({type: leadsConstants.GET_ALL_LEADS_FAILURE});
                })
                .catch((err) => {
                    dispatch({type: leadsConstants.GET_ALL_LEADS_FAILURE});
                });
        }
    }

    static updateLead(leadID, data) {
        return (dispatch) => {
            dispatch({type: leadsConstants.UPDATE_LEAD_REQUEST, payload: {leadID: leadID}});

            LeadsApi.updateLead(leadID, data)
                .then((res) => {

                    // if user not logged in
                    if(res.status === 403) {
                        dispatch({type: authConstants.USER_LOGGED_OUT});
                    }

                    return res.json();
                })
                .then((res) => {
                    // success
                    if(res.meta.success === true) {

                        // delete lead if interested === false
                        if(res.data.interested === false) {
                            dispatch({type: leadsConstants.DELETE_LEAD_SUCCESS, payload: {leadID: leadID}});
                        } else {
                            dispatch({type: leadsConstants.UPDATE_LEAD_SUCCESS, payload: res.data});
                        }
                        return;
                    }

                    return dispatch({type: leadsConstants.UPDATE_LEAD_FAILURE, payload: {leadID: leadID}});
                })
                .catch((err) => {
                    dispatch({type: leadsConstants.UPDATE_LEAD_FAILURE, payload: {leadID: leadID}});
                });
        }
    }
}


// WEBPACK FOOTER //
// ./src/actions/leads.js